import { NgModule } from '@angular/core';

import { AccessTokenService } from './access-token.service';
import { ConsumerLicenseService } from './consumer-license.service';
import { JumpListService } from './jump-list.service';
import { LocalAppLauncherService } from './local-app-launcher.service';
import { OfficeHomeAccessTokenService } from './office-home-access-token.service';
import { OfficeHomeConsumerLicenseService } from './office-home-consumer-license.service';
import { OfficeHomeJumpListService } from './office-home-jump-list.service';
import { OfficeHomeLocalAppLauncherService } from './office-home-local-app-launcher.service';
import { OfficeHomePinToTaskbarService } from './office-home-pin-to-taskbar.service';
import { OfficeHomeUtilityService } from './office-home-utility.service';
import { OfficeWorkloadsService } from './office-workloads.service';
import { PinToTaskbarService } from './pin-to-taskbar.service';
import { UiHostBootstrapperService } from './ui-host-bootstrapper.service';
import { UrlLauncherService } from './url-launcher.service';
import { UtilityService } from './utility.service';
import { WacBootstrapperService } from './wac-bootstrapper.service';
import { WindowUrlLauncherService } from './window-url-launcher.service';
import { WorkloadsService } from './workloads.service';

@NgModule({
    providers: [
        { provide: AccessTokenService, useClass: OfficeHomeAccessTokenService },
        { provide: ConsumerLicenseService, useClass: OfficeHomeConsumerLicenseService },
        { provide: JumpListService, useClass: OfficeHomeJumpListService },
        { provide: LocalAppLauncherService, useClass: OfficeHomeLocalAppLauncherService },
        { provide: PinToTaskbarService, useClass: OfficeHomePinToTaskbarService },
        { provide: UtilityService, useClass: OfficeHomeUtilityService },
        { provide: UrlLauncherService, useExisting: WindowUrlLauncherService },
        { provide: WorkloadsService, useClass: OfficeWorkloadsService },
        { provide: UiHostBootstrapperService, useClass: WacBootstrapperService }
    ]
})
export class OfficeHomeServicesModule {
}
